import * as React from 'react';
import * as styles from './styles.css';

import desktopImgSrc from './assets/desktopImg.svg';
import mobileImgSrc from './assets/mobileImg.svg';
import mobileReferralLogoSrc from './assets/mobileReferralLogo.svg';

import cx from 'clsx';

import { Button, UIHeading1, UIHeading2, UIText1 } from '@cian/ui-kit';
import { IconActionCopy16, IconActionShareIOS16 } from '@cian/ui-kit-design-tokens/icons';

interface IHeroProps extends React.PropsWithChildren {
  isDesktop?: boolean;
  hasReferrals?: boolean;
  onCopyLinkClick?: () => void;
  onShareLinkClick?: () => void;
  shareBtnRef?: React.Ref<HTMLButtonElement>;
  stickyRef?: React.Ref<HTMLDivElement>;
}

export const Hero: React.FC<IHeroProps> = ({
  isDesktop,
  hasReferrals,
  onCopyLinkClick,
  onShareLinkClick,
  children,
  stickyRef,
  shareBtnRef,
}) => {
  const HEADING =
    isDesktop && !hasReferrals ? (
      <>
        Порекомендуйте Сделку <br /> и получите 10 000 ₽
      </>
    ) : (
      <>
        Порекомендуйте <br /> Сделку и получите <br /> 10 000 ₽
      </>
    );

  return (
    <div className={styles['container']} ref={stickyRef}>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>
          <UIHeading1 color="text-inverted-default">{HEADING}</UIHeading1>
          <UIText1 color="text-inverted-default">
            Мы поможем людям решить вопрос с недвижимостью, а вы — заработаете
          </UIText1>

          {isDesktop && (
            <Button
              beforeIcon={<IconActionCopy16 color="icon-main-default" />}
              theme="fill_white_primary"
              size="L"
              onClick={onCopyLinkClick}
            >
              Пригласить по ссылке
            </Button>
          )}
        </div>

        {!isDesktop && (
          <div className={cx(styles['mobile-buttons'], { [styles['mobile-buttons-centered']]: !hasReferrals })}>
            {hasReferrals && <div>{children}</div>}
            {!hasReferrals && (
              <>
                <img src={mobileReferralLogoSrc} alt="Пригласите друга в Сделку" />

                <UIHeading2 color="text-primary-default">Здесь появятся все, кого вы пригласили</UIHeading2>
              </>
            )}

            <div className={styles['buttons']}>
              <Button
                beforeIcon={<IconActionCopy16 color="icon-main-default" />}
                theme="fill_white_primary"
                size="M"
                onClick={onCopyLinkClick}
                fullWidth
              >
                Скопировать ссылку-приглашение
              </Button>

              <Button
                ref={shareBtnRef}
                beforeIcon={<IconActionShareIOS16 color="icon-on-bright-default" />}
                theme="fill_primary"
                size="M"
                onClick={onShareLinkClick}
                fullWidth
              >
                Поделиться ссылкой
              </Button>
            </div>
          </div>
        )}

        {isDesktop && hasReferrals && <div>{children}</div>}
        {isDesktop && !hasReferrals && (
          <div className={styles['desktop-img']}>
            <img src={desktopImgSrc} alt="Пригласите друга в Сделку" />
          </div>
        )}

        {!isDesktop && (
          <div className={styles['mobile-img']}>
            <img src={mobileImgSrc} alt="Пригласите друга в Сделку" />
          </div>
        )}
      </div>
    </div>
  );
};
